<template>
    <div>
        <page-title class="card-header bg-primary text-white"
                    :title="$t('rankingCriteria.title')"
                    :showTitle="true"></page-title>
        <RankingCriteriaGrid :returnUrl="returnUrl"
                             :showSettingsBtn="showSettingsBtn"
                             :showBtns="showBtns"
                             :showNewButton="showNewButton">
        </RankingCriteriaGrid>
    </div>
</template>

<script>
    import RankingCriteriaGrid from "@/components/rankingCriteria/RankingCriteriaGrid";
    import PageTitle from '@/components/common/PageTitle';

    export default {
        name: 'list-ranking-criteria',
        components: {
            RankingCriteriaGrid,
            PageTitle
        },
        props: {
            showBtns: {
                default: true,
                type: Boolean
            },
            showSettingsBtn: {
                default: true,
                type: Boolean
            },
            showNewButton: {
                default: true,
                type: Boolean
            },
        },
        data() {
            return {
                returnUrl: '/registers/rankingCriteria',
            };
        },
        methods: {

        }
    }
</script>

<style scoped>
</style>
